export class ApiError extends Error {
  message = '일시적인 오류입니다. 잠시 후 다시 이용해주세요';
  redirectUrl: string = '';
  notFound: boolean = false;
}

export class BadRequest extends ApiError {
  message: string;

  constructor(message: string) {
    super();
    this.message = message;
  }
  toString() {
    return this.message;
  }
}
